module.exports = __webpack_public_path__ + "img/cp-5.5a3004bf.jpg";